import axios from 'axios';
import config from '../config';

const { api } = config;

const ramoAtividadeAxios = axios.create({
  baseURL: `${api.API_URL}/api/ramos-atividade`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
ramoAtividadeAxios.interceptors.request.use(
  (config) => {
    const authUser = sessionStorage.getItem('authUser');
    if (authUser) {
      const user = JSON.parse(authUser);
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
ramoAtividadeAxios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Erro ao buscar Ramo de Atividade';
    return Promise.reject(new Error(message));
  }
);

export interface RamoAtividadeDto {
  id: string;
  nome: string;
  descricao: string | null;
  isActive: boolean;
}

/**
 * Ramo de Atividade Service
 */
export const ramoAtividadeService = {
  /**
   * Get all active Ramos de Atividade
   */
  getAllActive: async (): Promise<RamoAtividadeDto[]> => {
    return ramoAtividadeAxios.get('/');
  },

  /**
   * Get Ramo de Atividade by ID
   */
  getById: async (id: string): Promise<RamoAtividadeDto> => {
    return ramoAtividadeAxios.get(`/${id}`);
  },

  /**
   * Create a new Ramo de Atividade
   */
  create: async (data: { nome: string; descricao?: string }): Promise<RamoAtividadeDto> => {
    return ramoAtividadeAxios.post('/', data);
  },

  /**
   * Update an existing Ramo de Atividade
   */
  update: async (id: string, data: { nome: string; descricao?: string }): Promise<void> => {
    return ramoAtividadeAxios.put(`/${id}`, data);
  },

  /**
   * Deactivate a Ramo de Atividade
   */
  deactivate: async (id: string): Promise<void> => {
    return ramoAtividadeAxios.post(`/${id}/deactivate`);
  },

  /**
   * Activate a Ramo de Atividade
   */
  activate: async (id: string): Promise<void> => {
    return ramoAtividadeAxios.post(`/${id}/activate`);
  },
};

export default ramoAtividadeService;
